import { v4 as uuidv4 } from 'uuid'

import type { IStop } from '../../../../../types/shipment'
import type { ISearchResultDTO } from '../../../../../types/stop'

/**
 * This function generates a stop object from a search result
 * @param searchResult
 * @param stopsLength
 * @returns
 */
export const generateStopDetailsFromSearchResult = (searchResult: ISearchResultDTO, stopsLength: number): IStop => {
  const {
    addressLabel,
    gpsCoordinates,
    address,
    title,
    type: category,
    rating,
    reviews,
    placeID,
    thumbnail = null
  } = searchResult

  const stop: IStop = {
    appointment: null,
    arrivalDateTime: null,
    departureDateTime: null,
    eta: null,
    id: uuidv4(),
    instructions: null,
    referenceNumber: null,
    sequence: stopsLength ? stopsLength + 1 : 1,
    type: stopsLength === 0 ? 'Pick' : 'Drop',
    warehouse: {
      address: {
        addressLabel: addressLabel,
        city: address.city,
        coordinates: gpsCoordinates
          ? {
              latitude: gpsCoordinates.latitude,
              longitude: gpsCoordinates.longitude
            }
          : null,
        country: address.country,
        countryCode: address.countryCode,
        county: address.country,
        postalCode: address.postalCode,
        postalCodeSuffix: address.postalCodeSuffix,
        state: address.state,
        stateCode: address.stateCode,
        street: address.street,
        streetNumber: address.streetNumber
      },
      category,
      geofence: null,
      locationID: null,
      name: title,
      placeID,
      rating,
      reviews,
      thumbnail,
      warehouseHours: null
    }
  }

  return stop
}
